import { combineReducers } from 'redux';
import privileges from './privileges';
import modules from './modules';
import layout from './layout';
import gruser from './gruser';
import page from './page';
const rootReducers = {
    privileges,
    modules,
    layout,
    gruser,
    page
};
export default combineReducers(rootReducers);
